const MIN = 60_000
const HOUR = 60 * MIN
const DAY = 24 * HOUR

export function formatRelative(
  input: Date | string | null | undefined,
  now: Date = new Date(),
): string {
  if (input === null || input === undefined) return '—'
  const t = typeof input === 'string' ? new Date(input) : input
  if (Number.isNaN(t.getTime())) return '—'
  const diff = now.getTime() - t.getTime()
  if (diff < MIN) return 'только что'
  if (diff < HOUR) return `${Math.floor(diff / MIN)} мин назад`
  if (diff < DAY) return `${Math.floor(diff / HOUR)} ч назад`
  return `${Math.floor(diff / DAY)} д назад`
}
